/**
 * Shared CSS color-filter helpers for community image/video editors.
 * Filters change look only; file size is controlled by the encode/compress step.
 */

export function clampEdit(value, min, max) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(min, Math.min(max, n));
}

/**
 * @param {{ brightness?: number, contrast?: number, saturation?: number, warmth?: number }} [edits]
 * @returns {string} CSS filter string
 */
export function buildColorCssFilter({
  brightness = 0,
  contrast = 0,
  saturation = 0,
  warmth = 0,
} = {}) {
  const b = 1 + clampEdit(brightness, -50, 50) / 100;
  const c = 1 + clampEdit(contrast, -50, 50) / 100;
  const s = 1 + clampEdit(saturation, -50, 50) / 100;
  const w = clampEdit(warmth, -40, 40);
  // Warm: light sepia + slight orange hue. Cool: blue-ish hue-rotate.
  const sepia = Math.max(0, w) / 100 * 0.5;
  const hue = w * -0.35;
  return `brightness(${b}) contrast(${c}) saturate(${s}) sepia(${sepia}) hue-rotate(${hue}deg)`;
}

/**
 * @param {{ brightness?: number, contrast?: number, saturation?: number, warmth?: number }} [edits]
 */
export function hasColorEdits({
  brightness = 0,
  contrast = 0,
  saturation = 0,
  warmth = 0,
} = {}) {
  return (
    Math.abs(Number(brightness) || 0) >= 0.5 ||
    Math.abs(Number(contrast) || 0) >= 0.5 ||
    Math.abs(Number(saturation) || 0) >= 0.5 ||
    Math.abs(Number(warmth) || 0) >= 0.5
  );
}
